module.exports = __webpack_public_path__ + "img/trash.3256081d.svg";